export const icons = {
  app: require('./app.png').default,
  'generic-icon': require('./generic-icon.png').default,
  calendar: require('./calendar.png').default,
  category: require('./category.png').default,
  'eighteen-plus': require('./eighteen-plus.png').default,
  'emergency-contraception': require('./emergency-contraception.png').default,
  'menstrual-health': require('./menstrual-health.png').default,
  monitor: require('./monitor.png').default,
  'question-form': require('./question-form.png').default,
  underage: require('./underage.png').default,
  'urinating-more-than-usual': require('./urinating-more-than-usual.png').default,
  'blood-in-your-urine': require('./blood-in-your-urine.png').default,
  'burning-feeling-during-urination': require('./blood-in-your-urine.png').default,
  'swelling-around-the-vagina': require('./swelling-around-the-vagina.png').default,
  'soreness-redness-around-vagina': require('./swelling-around-the-vagina.png').default,
  'vaginal-itching': require('./swelling-around-the-vagina.png').default,
  'abnormal-vaginal-discharge': require('./swelling-around-the-vagina.png').default,
  'foul-smelling-vaginal-odor': require('./swelling-around-the-vagina.png').default,
  'pain-during-sex': require('./pain-during-sex.png').default,
  'birth-control-request': require('./birth-control-request.png').default,
  'ease-logo': require('./ease-logo.png').default,
  atome: require('./atome-logo.svg').default,
  clock: require('./clock.png').default,
  'tell-us': require('./tell-us.png').default,
  'we-review': require('./we-review.png').default,
  'we-test': require('./we-review.png').default,
  'we-deliver': require('./we-deliver.png').default,
  'we-support': require('./we-support.png').default,
  'you-receive': require('./we-support.png').default,
  star: require('./star.png').default,
  'student-ease-logo': require('./student-ease-logo.png').default,

  //Menstrual health
  'bleeding-that-disrupts-daily-life': require('./urinating-more-than-usual.png').default,
  'light-bleeding-after-sex': require('./blood-in-your-urine.png').default,
  'light-bleeding-between-periods': require('./blood-in-your-urine.png').default,
  'pain-radiating-down-the-legs': require('./swelling-around-the-vagina.png').default,
  'severe-lower-back-pain': require('./swelling-around-the-vagina.png').default,
  'severe-cramps-in-lower-abdomen': require('./swelling-around-the-vagina.png').default,
  'dizziness-or-fainting': require('./swelling-around-the-vagina.png').default,
  'lacking-energy-or-weakness': require('./swelling-around-the-vagina.png').default,
  'nausea-or-vomiting': require('./pain-during-sex.png').default,

  //Acne Teleconsultation
  'acne-teleconsultation': require('./acne-teleconsultation.png').default,

  //Hair Loss teleconsultation
  'hair-loss': require('./hair-loss.png').default,
  'thinning-hair': require('./thinning-hair.png').default,
  'bald-spots': require('./bald-spots.png').default,
  'sudden-onset-of-hair-loss': require('./sudden-onset-of-hair-loss.png').default,
  'painful-itchy-skin-scalp': require('./painful-itchy-skin-scalp.png').default,
  'hair-loss-in-other-body-parts': require('./hair-loss-in-other-body-parts.png').default,
  'red-rings-or-rashes-in-scalp': require('./red-rings-or-rashes-in-scalp.png').default,
  'rashes-elsewhere-on-body': require('./rashes-elsewhere-on-body.png').default,
  'acne-or-other-skin-issues': require('./acne-or-other-skin-issues.png').default,

  check: require('./check.png').default,
  'chevron-left': require('./chevron-left.png').default,
  'chevron-right': require('./chevron-right.png').default,
  // --------------------- Birth Control Pill Patch------------------------
  'bc-3rd-pill': require('./birth-control-pill-patch/bc-3rd-pill.png').default,
  'bc-leading-pill': require('./birth-control-pill-patch/bc-leading-pill.png').default,
  'bc-low-pill': require('./birth-control-pill-patch/bc-low-pill.png').default,
  'bc-patch': require('./birth-control-pill-patch/bc-patch.png').default,
  'patch-1-pack': require('./birth-control-pill-patch/patch-1-pack.png').default,
  'patch-3-pack': require('./birth-control-pill-patch/patch-3-pack.png').default,
  'patch-6-pack': require('./birth-control-pill-patch/patch-6-pack.png').default,
  'patch-12-pack': require('./birth-control-pill-patch/patch-12-pack.png').default,
  'pill-1-pack': require('./birth-control-pill-patch/pill-1-pack.png').default,
  'pill-3-pack': require('./birth-control-pill-patch/pill-3-pack.png').default,
  'pill-6-pack': require('./birth-control-pill-patch/pill-6-pack.png').default,
  'pill-12-pack': require('./birth-control-pill-patch/pill-12-pack.png').default,
  'patch-top-icon': require('./birth-control-pill-patch/patch-top-icon.png').default,

  //------------------- WEIGHT_LOSS_PROGRAM------------------------//
  assessment: require('./tell-us.png').default,
  consultation: require('./we-review.png').default,
  commencement: require('./we-deliver.png').default,
  'bmi-overweight': require('./sorry-page-weight-loss.png').default,
  'bmi-healthy': require('./sorry-page-weight-loss.png').default,
  'bmi-underweight': require('./sorry-page-weight-loss.png').default,
  'bmi-allergic': require('./sorry-page-weight-loss.png').default,
  // ------------------MENOPAUSE TELECONSULTATION-------------------//
  'difficulty-sleeping': require('./difficulty-sleeping.png').default,
  'hot-flashes': require('./hot-flashes.png').default,
  'joint-pain': require('./joint-pain.png').default,
  'low-libido': require('./low-libido.png').default,
  'mood-changes': require('./mood-changes.png').default,
  'skin-irritation': require('./skin-irritation.png').default,
  'urinary-issues': require('./urinary-issues.png').default,
  'vaginal-symptoms': require('./vaginal-symptoms.png').default,
  'weight-gain': require('./weight-gain.png').default,
};

export type IconTypes = keyof typeof icons;
